
import global from '../../../static/js/global'
import loadPage from '../../components/loadingPage'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import { log } from 'util';
export default {
data() {
return {
pkCode:'',
iconType: "",
title: "我的车位",
mylist1:[],
mylistcar:[],
nums:'1',
show_1:false,//控制是否显示loading动画效果
phone:"",
comnCode:'',
hies:false,
carId:'',
index:'',
phone:'',
show_3:true,//控制是否显示车量信息
showprompt:false,
prompt:'',
openid:'',
show_2:false,//如果有车位信息，没有绑定车辆，则显示提示信息
pkUsed:'',
show_4:false,//如果有车位并绑定一辆车，则显示下面的添加信息
show_5:false,//如果没有车位信息，并且没绑定车辆，则提示想绑定找物业去
show_6:true,//如果车位信息则显示该页面
carMaxNumber:[] 
};
},
components: {
XHeader,
XTable,
Alert,
Flexbox,
FlexboxItem,
XInput,
Group,
loadPage,
XButton
},
computed:{

},
beforeMount(){
this.show_1 = true;
if(this.$router.history.current.path == "/myCarInfo"){
document.title = "我的车位";
}
this.openid=this.$router.history.current.query.openid
this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone +'&openid=' + this.$router.history.current.query.openid).then(function(res){
let rsults = res.body.result;
this.carMaxNumber = new Object();
for(let ms in rsults){
this.carMaxNumber[ms] = rsults[ms];
}
/*console.log("&&&&&&&&&&&&&&&&&&&&&")
console.log(this.carMaxNumber)*/
if(res.body.result.length>0){
let data = res.body.result[0];
console.log("####################");
console.log(data);
this.comnCode = data.comn_code;
this.phone=this.$router.history.current.query.phone;
/*this.pkCode=this.$router.history.current.query.pkCode;
this.carId=this.$router.history.current.query.carId;
this.pkId=this.$router.history.current.query.pkId;*/

let url1=global.host + 'parkinginfo/getByPhone?phone='+this.phone+"&comnCode="+ this.comnCode;
this.$http.get(url1).then(function(res){
this.show_1 = false;
if(res.body.result.length>0){
this.show_5 = false;
}else{
this.show_5 = true;
}
res.body.result.map((item)=>{//遍历返回的对象，并设置相应对象的值
item.park.pkUsed = item.park.pkUsed==='1'?'租赁':'购买';

if(item.car.length<=this.carNumber){
this.show_4=true;
}else {
this.show_4=false;
}
})
this.mylist1 = res.body.result;
console.log('!!!!!!!!!!!');
console.log(res);
},
function(err){
console.log(err)
})
}else{
this.show_1 = false;
this.show_6=false;
this.show_5=true;
}
},
function(err){
console.log(err)
})
},
methods:{
deleteCarInfo(carId){//删除绑定的车量信息
let delUrl=global.host + 'carInfo/deleteCarInfo?carId='+carId+'&phone='+this.phone+'&pkCode='+this.$router.history.current.query.pkCode;;
console.log(delUrl);
var this_ = this;
this.$http.get(delUrl).then(function(res){
if(res.body.statusCode=='110'){
this_.$router.go(0);
return true;
}else{
this.showprompt = true;
this.prompt = "删除失败,请重试！";
}
})
}
}
};



// WEBPACK FOOTER //
// ./src/components/carRentComponents/myCarInfo.vue